import React from 'react'
import PropTypes from 'prop-types'
import { renderReactComponents } from '../Utilities/RichTextRenderer'

function ModalMessage({ data }) {
  const { modalInformation, handleModal, successfulResponse, failedResponse } = data

  let formModalMessage

  if (modalInformation?.success) {
    const textData = {
      richText: successfulResponse,
      onEvent: handleModal
    }
    formModalMessage = renderReactComponents(textData)

    if (modalInformation?.destination) {
      window.setTimeout(function () {
        window.location.replace(modalInformation?.destination)
      }, 3000)
    }
  } else if (!modalInformation.response) {
    formModalMessage = (
      <>
        <h2 className="modal__headline headline headline--effra-small">
          Sorry, we were unable to check your information because of an issue on our end.
        </h2>
        <p className="headline headline--medium">Please resubmit your information</p>
      </>
    )
  } else {
    const textData = {
      richText: failedResponse,
      onEvent: handleModal
    }

    formModalMessage = renderReactComponents(textData)
  }

  return formModalMessage
}

ModalMessage.propTypes = {
  data: PropTypes.object
}

export default ModalMessage
